import Add from '@mui/icons-material/Add'
import { Button, Grid, Stack, Typography } from '@mui/material'
import { FEATURE_BUNDLE_TYPES_ARRAY } from 'src/consumer/constants'
import { checkAndGetTargetValue } from 'src/consumer/helpers/utilFunctions'
import FeatureBundleComponent from './featureBundles/FeatureBundleComponent'

export default function BundlePackCustomPriceComponent({
  bundle,
  setSelectedPlan,
  allOneOnOnePlans,
  bundleEditorMode = 'session',
}) {
  const isLegacyBundle = bundleEditorMode === 'legacy'

  function setBundle(value) {
    setSelectedPlan((prev) => {
      if (typeof value === 'function') {
        return { ...(prev || {}), bundle: value(prev?.bundle || []) }
      }
      return { ...(prev || {}), bundle: value }
    })
  }

  function deleteBundle(idx) {
    setSelectedPlan((prev) => {
      const newBundles = [...prev.bundle]
      newBundles.splice(idx, 1)
      return { ...prev, bundle: newBundles }
    })
  }

  function changeBundle(eve, idx) {
    setSelectedPlan((prev) => ({
      ...(prev || {}),
      bundle: (prev?.bundle || []).map((item, index) =>
        index === idx ? { ...item, [eve?.target?.id]: checkAndGetTargetValue(eve) } : item,
      ),
    }))
  }

  function addBundle() {
    setBundle((prev) =>
      prev
        ? [...prev, { type: FEATURE_BUNDLE_TYPES_ARRAY?.[0]?.id, maxCount: 1 }]
        : [{ type: FEATURE_BUNDLE_TYPES_ARRAY?.[0]?.id, maxCount: 1 }],
    )
  }

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}
      >
        <Stack spacing={0.5}>
          <Typography sx={{ fontWeight: 700 }}>
            {isLegacyBundle ? 'Included Appointment Plans' : 'Bundles'}
          </Typography>
          {isLegacyBundle ? (
            <Typography variant="body2" color="text.secondary">
              Add every appointment pricing plan that this booking pack can redeem against.
            </Typography>
          ) : null}
        </Stack>
        <Button variant="outlined" startIcon={<Add />} onClick={addBundle}>
          {isLegacyBundle ? 'Add Appointment Plan' : 'Add Bundle'}
        </Button>
      </Grid>
      {bundle?.map((bndl, idx) => (
        <Grid item xs={12} key={idx}>
          <FeatureBundleComponent
            bundle={bndl}
            deleteBundle={() => {
              deleteBundle(idx)
            }}
            changeBundle={(eve) => changeBundle(eve, idx)}
            disabled={false}
            subscriptionPlansToUse={allOneOnOnePlans}
            bundleEditorMode={bundleEditorMode}
          />
        </Grid>
      ))}
    </Grid>
  )
}
